module.exports = __webpack_public_path__ + "img/icon_success.c286d1f5.png";